import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Plural, Trans, t } from "@lingui/macro";

import { i18n } from "base/i18n";
import { Popover, POPOVER_POSITIONS, POPOVER_TRIGGERS } from "widgets/popover";
import { Icon } from "widgets/datadisplay";
import { Tooltip, TOOLTIP_POSITION, Toast } from "widgets/feedback";
import { AccessCtrl } from "widgets/others";
import { useUserStore } from "base/stores";
import { ROLES as BASEROLES, PRODUCT_TYPES } from "base/constants";

import { ReactionTypeComponent } from "./reaction.type.component";
import { ReactionModal } from "./reaction.modal";
import { PostViewsModal } from "./post.views.modal";
import {
  CHANNEL_ROLES,
  REACTION_ICON,
  REACTION_TYPE
} from "../../common/utils/constant";
import { onUpdateBookmark } from "@/common/utils/utils";

import "../comment/popover.override.css";
import styles from "./reaction.css";

import PostViewIcon from "../../icons/PostView.svg";
import BookmarkIcon from "@/common/icons/Bookmark.svg";
import BookmarkedIcon from "@/common/icons/Bookmarked.svg";

const { showSuccess } = Toast;

ReactionComponent.propTypes = {
  postReaction: PropTypes.func,
  state: PropTypes.object,
  setShowReactionModal: PropTypes.func,
  showReactionModal: PropTypes.bool,
  isComment: PropTypes.bool,
  creatorId: PropTypes.string,
  seenCount: PropTypes.number,
  roles: PropTypes.array,
  medium: PropTypes.string,
  mediumId: PropTypes.string,
  teamId: PropTypes.string,
  instanceId: PropTypes.string,
  isBookmarked: PropTypes.bool,
  updateBookmarkList: PropTypes.func
};

export function ReactionComponent(props) {
  const {
    postReaction,
    state,
    setShowReactionModal,
    showReactionModal,
    isComment,
    creatorId,
    seenCount,
    roles,
    medium,
    mediumId,
    teamId,
    instanceId,
    isBookmarked,
    updateBookmarkList
  } = props;
  const { Product } =
    window.accountDetails.UserDetails.AccountDetails.LicenseInfo;

  const [showViewModal, setShowViewModal] = useState(false);
  const [isMarkingBookmark, setBookmark] = useState(false);

  useEffect(
    function setBookmarks() {
      setBookmark(isBookmarked);
    },
    [isBookmarked]
  );

  function getnameLength(name) {
    if (name.length > 50) {
      return "";
    } else {
      return (
        <span className="smallplus">
          {(state.isCurrentUserReacted ? ", " : " ") + name}
        </span>
      );
    }
  }

  let { currentUser } = useUserStore.getState();
  let lastNameCount = Object.keys(state.lastName).length;
  let ReactedIcon = REACTION_ICON[state.currentReactionType.Name];
  let currentUserReacted = state.isCurrentUserReacted ? 2 : 1;
  let fillType = "";
  if (state.currentReactionType.image === "Like") {
    ReactedIcon = REACTION_ICON["LikeMain"];
    fillType = "var(--primary-blue-500)";
  } else if (state.currentReactionType.image === "Like-outline") {
    ReactedIcon = REACTION_ICON["LikeOutline"];
    fillType = "var(--primary-blue-500)";
  }

  function showAddSuccess() {
    showSuccess({ message: i18n._(t`The post was added to your bookmarks`) });
  }
  function showRemoveSuccess() {
    showSuccess({
      message: i18n._(t`The post was removed from your bookmarks`)
    });
  }

  return (
    <div
      className={
        isComment ? styles.reactionWrapper : styles.noCommentRectionWrapper
      }
    >
      <div className={styles.reactionItemContainer}>
        <Popover
          trigger={[POPOVER_TRIGGERS.HOVER]}
          position={POPOVER_POSITIONS.TOP}
          className={`reactionpopover`}
          getContainer={() => document.body}
          targetRenderer={() => {
            return (
              <div className={styles.reactionItemWrapper}>
                <div
                  className={`${styles.reactionItem}`}
                  onClick={() => postReaction(state.currentReactionType.Name)}
                >
                  <ReactedIcon width={16} height={16} fill={fillType} />
                  <div
                    className={styles.reactionText}
                    style={{ color: state.currentReactionType.color }}
                  >
                    {i18n._(REACTION_TYPE[state.currentReactionType.Name])}
                  </div>
                </div>
              </div>
            );
          }}
        >
          <div className={styles.hoverReactionContainer}>
            <ReactionTypeComponent postReaction={postReaction} />
          </div>
        </Popover>
      </div>
      <Popover
        className={"showreactions"}
        trigger={[POPOVER_TRIGGERS.HOVER]}
        position={POPOVER_POSITIONS.TOP}
        targetRenderer={() => {
          return (
            <div
              className={styles.reactionContainer}
              onClick={() => setShowReactionModal(true)}
            >
              <div className={styles.reactionIcon}>
                {Object.keys(state.reactionsGroupBy).map((reactionItem) => {
                  const ReactedIcon = REACTION_ICON[reactionItem];
                  return (
                    <ReactedIcon
                      key={reactionItem}
                      width={16}
                      height={16}
                      style={{ marginRight: 2 }}
                    />
                  );
                })}
              </div>
              <div className={styles.reactionNameWrapper}>
                <div>
                  {state.reactions.length === 1 && (
                    <span className={styles.selectedreactionname}>
                      {state.lastName}
                    </span>
                  )}
                  {state.reactions.length > 1 && state.reactions.length < 3 && (
                    <React.Fragment>
                      {state.isCurrentUserReacted ? (
                        <span className={styles.selectedreactionname}>
                          <Trans>You</Trans>
                        </span>
                      ) : (
                        state.lastName.slice(0, 1).map((name, index) => {
                          return (
                            <span
                              key={index}
                              id={index}
                              className={styles.selectedreactionname}
                            >
                              {(index ? ", " : "") + name}
                            </span>
                          );
                        })
                      )}
                      <span className={styles.selectedreactionname}> and</span>{" "}
                      {state.isCurrentUserReacted ? (
                        <span className={styles.selectedreactionname}>
                          {state.lastName[lastNameCount - 1]}
                        </span>
                      ) : (
                        <span className={styles.selectedreactionname}>
                          <Trans>1 other</Trans>
                        </span>
                      )}
                    </React.Fragment>
                  )}
                  {state.reactions.length > 2 && (
                    <React.Fragment>
                      {state.isCurrentUserReacted && (
                        <span className={styles.selectedreactionname}>
                          <Trans>You</Trans>
                        </span>
                      )}
                      {state.lastName.slice(0, 1).map(() => {
                        return getnameLength(state.lastName[0]);
                      })}
                      &nbsp;
                      <span className={styles.selectedreactionname}>
                        <Trans>and</Trans>
                      </span>{" "}
                      {
                        <span className={styles.selectedreactionname}>
                          {state.lastName[0].length < 50
                            ? state.reactions.length - currentUserReacted
                            : state.reactions.length - 1}{" "}
                          <Trans>others</Trans>
                        </span>
                      }
                    </React.Fragment>
                  )}
                </div>
              </div>
            </div>
          );
        }}
      >
        <ul className={styles.showReactionWrapper}>
          {state.reactions.slice(0, 15).map((reactionItem) => {
            const ReactedIcon = REACTION_ICON[reactionItem.ReactionType];
            return (
              <li key={reactionItem.Name}>
                <ReactedIcon style={{ margin: "2px 0" }} />
                <span className={`${styles.reactedreactionname} smallplus`}>
                  {reactionItem.Name}
                </span>
              </li>
            );
          })}
          {state.reactions.length > 15 && (
            <li>
              <span>&nbsp;</span>
              <span className={`${styles.reactedreactionname} smallplus`}>
                <Trans>and</Trans> {state.reactions.length - 15}{" "}
                <Trans>More</Trans>
              </span>
            </li>
          )}
        </ul>
      </Popover>
      {seenCount > 0 && (
        <AccessCtrl
          canAccess={() =>
            currentUser.UserType === BASEROLES.SUPER_ADMIN ||
            currentUser._id === creatorId
          }
          roles={[CHANNEL_ROLES.ADMIN]}
          flowRoles={roles}
        >
          <Tooltip
            content={
              <Plural
                value={seenCount}
                one="# member viewed this post"
                other="# members viewed this post"
              />
            }
            position={TOOLTIP_POSITION.TOP}
          >
            <div
              className={styles.postViewWrapper}
              onClick={() => setShowViewModal(true)}
            >
              <Icon paddingNone={true}>
                <PostViewIcon />
              </Icon>
              <span>{seenCount}</span>
            </div>
          </Tooltip>
        </AccessCtrl>
      )}
      {Product !== PRODUCT_TYPES.KF_COMMUNITY && (
        <>
          {isMarkingBookmark ? (
            <Tooltip content={i18n._(t`Remove bookmark`)}>
              <div
                onClick={(e) => {
                  onUpdateBookmark({
                    e,
                    teamId,
                    mediumId,
                    instanceId,
                    isAdd: false,
                    isPost: true,
                    updateBookmark: updateBookmarkList,
                    showSuccess: showRemoveSuccess
                  });
                  setBookmark(false);
                }}
                className={styles.bookmarkIcon}
              >
                <BookmarkedIcon
                  width={16}
                  height={16}
                  fill={"var(--icon-dark-gray)"}
                />
              </div>
            </Tooltip>
          ) : (
            <Tooltip content={i18n._(t`Bookmark this post`)}>
              <div
                onClick={(e) => {
                  onUpdateBookmark({
                    e,
                    teamId,
                    mediumId,
                    instanceId,
                    isAdd: true,
                    isPost: true,
                    updateBookmark: updateBookmarkList,
                    showSuccess: showAddSuccess
                  });
                  setBookmark(true);
                }}
                className={styles.bookmarkIcon}
              >
                <BookmarkIcon fill={"var(--icon-dark-gray)"} />
              </div>
            </Tooltip>
          )}
        </>
      )}
      {showReactionModal && (
        <ReactionModal
          onClose={() => setShowReactionModal(false)}
          reactions={state.reactionsGroupBy}
          totalReactions={state.reactions}
        />
      )}
      {showViewModal && (
        <PostViewsModal
          onClose={() => setShowViewModal(false)}
          title={
            <Plural
              value={seenCount}
              one="# member viewed this post"
              other="# members viewed this post"
            />
          }
          medium={medium}
          teamId={teamId}
          mediumId={mediumId}
          instanceId={instanceId}
        />
      )}
    </div>
  );
}
